import { NavBar, Form, Button, Input, DatePicker, Selector, Toast } from 'antd-mobile'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import '../index.css';
import moment from "moment";
import { gameYearApi } from '../../features/game-year/api/gameYearApi';
import { teamApi } from '../../features/team/api/teamApi';

export default function CreateGamePk() {

    const [buttomLoading, setButtomLoading] = useState(false)
    const [teamInfoList, setTeamInfoList] = useState([])

    const location = useLocation();
    const gameYearId = location?.state?.gameYearId;
    const getTeamList = useCallback(() => {
        Toast.show({ icon: 'loading' })
        teamApi.getList(gameYearId)
            .then(function (response) {
                setTeamInfoList(response.data.data || [])
            })
            .catch(function (error) {
                console.error('获取队伍列表失败', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameYearId])

    useEffect(() => {
        if (!gameYearId) {
            Toast.show({ content: '缺少必要参数', icon: 'fail' });
            window.history.back();
            return;
        }
        getTeamList()
    }, [gameYearId, getTeamList])

    const createGamefunc = (values) => {
        const teamA = values.teamA?.[0];
        const teamB = values.teamB?.[0];

        if (!teamA || !teamB) {
            Toast.show({ content: '请选择对战双方', icon: 'fail' });
            return;
        }
        if (teamA.id === teamB.id) {
            Toast.show({ content: '对战双方不能是同一队', icon: 'fail' });
            return;
        }
        const matchTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');
        Toast.show({ icon: 'loading', duration: 0 })
        setButtomLoading(true)

        gameYearApi.createMatch({
            gameYearId: gameYearId,
            redTeamId: teamB.id,
            greenTeamId: teamA.id,
            redTeamName: teamB.teamName,
            greenTeamName: teamA.teamName,
            startTime: matchTime,
            // 标题留空时自动由双方队名生成，减少管理员重复输入。
            gameName: values.gameName?.trim() || `${teamA.teamName} VS ${teamB.teamName}`,
            redCaptainId: teamB.teamCaptain,
            greenCaptainId: teamA.teamCaptain,
            greenColor: values.greenColor?.[0],
            redColor: values.redColor?.[0],
            // 年会比赛也需要明确保存赛段节数，供比赛中控制按钮判断赛程。
            gameCourse: Number(values.gameCourse?.[0]),
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '比赛创建成功！',
                        icon: 'success',
                        afterClose: () => window.history.back(),
                    })
                } else {
                    Toast.show({ content: response.data.msg, icon: 'fail' })
                }
            })
            .catch(function () {
                Toast.show({ content: '创建失败', icon: 'fail' })
            })
            .finally(() => {
                setButtomLoading(false)
            });
    }

    const colorOptions = [
        { label: '红色', value: 'red' },
        { label: '绿色', value: 'green' },
        { label: '紫白', value: '#CCCCFF' },
    ];

    const [form] = Form.useForm()
    const datePickerRef = useRef();
    
    // Watch color and team selections for dynamic UI updates and exclusivity
    const selectedColorA = Form.useWatch('greenColor', form)?.[0];
    const selectedColorB = Form.useWatch('redColor', form)?.[0];
    const selectedTeamA = Form.useWatch('teamA', form)?.[0];
    const selectedTeamB = Form.useWatch('teamB', form)?.[0];
    const generatedTitle = selectedTeamA && selectedTeamB
        ? `${selectedTeamA.teamName} VS ${selectedTeamB.teamName}` : '选好双方后自动生成';

    const getDynamicCardStyle = (colorValue) => {
        if (!colorValue) return { 
            border: '2px solid #E5E6EB', 
            background: '#fff',
            borderRadius: '20px',
            padding: '16px',
            transition: 'all 0.3s ease',
            marginBottom: '20px'
        };
        
        const colorMap = {
            'red': '#FF4D4F',
            'green': '#00B42A',
            '#CCCCFF': '#9292FF'
        };
        const themeColor = colorMap[colorValue] || colorValue;
        
        return {
            border: `2px solid ${themeColor}`,
            boxShadow: `0 0 20px ${themeColor}30`,
            background: '#fff',
            borderRadius: '20px',
            padding: '16px',
            transition: 'all 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
            marginBottom: '20px'
        };
    };

    const getDynamicLabelStyle = (colorValue) => {
        const colorMap = {
            'red': '#FF4D4F',
            'green': '#00B42A',
            '#CCCCFF': '#6B6BFF'
        };
        return { 
            fontSize: '17px', 
            fontWeight: '900', 
            color: colorMap[colorValue] || '#1D2129',
            transition: 'color 0.3s ease'
        };
    };

    return (
        <div className="create-team-page has-unified-nav" style={{ background: '#F7F8FA', minHeight: '100vh' }}>
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                创建对战赛事
            </NavBar>

            <div className="create-team-form-container" style={{ padding: '24px 16px' }}>
                <Form
                    form={form}
                    initialValues={{ gameCourse: [2], greenColor: ['green'], redColor: ['red'] }}
                    layout='vertical'
                    onFinish={createGamefunc}
                    footer={
                        <div style={{ marginTop: '30px' }}>
                            <Button
                                block
                                type='submit'
                                color='primary'
                                size='large'
                                style={{ 
                                    height: '56px', 
                                    borderRadius: '18px', 
                                    fontSize: '18px', 
                                    fontWeight: '850',
                                    boxShadow: '0 8px 16px rgba(22, 93, 255, 0.25)',
                                    background: '#165DFF'
                                }}
                                loading={buttomLoading}
                            >
                                发布本场对决
                            </Button>
                        </div>
                    }
                >
                    {/* Part 1: Basic Info */}
                    <div className="create-team-card" style={{ marginBottom: '18px', background: '#fff', borderRadius: '20px', padding: '16px', border: '1px solid #F2F3F5' }}>
                        <div style={{ fontSize: '16px', fontWeight: '850', color: '#1D2129', marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '4px', height: '18px', background: '#165DFF', borderRadius: '2px', marginRight: '10px' }}></span>
                            赛事基础信息
                        </div>
                        <Form.Item
                            name='gameName'
                            label={<span style={{ fontSize: '13px', fontWeight: '750', color: '#4E5969' }}>对决标题（选填）</span>}
                        >
                            <Input placeholder={generatedTitle} style={{ fontSize: '15px', fontWeight: '600' }} />
                        </Form.Item>

                        <Form.Item
                            name='gameCourse'
                            label={<span style={{ fontSize: '13px', fontWeight: '750', color: '#4E5969' }}>比赛赛段</span>}
                            rules={[{ required: true, message: '请选择比赛赛段' }]}
                        >
                            {/* 创建时明确选择节数，避免进行中页面无法判断下一步操作。 */}
                            <Selector
                                columns={3}
                                options={[
                                    { label: '单节', value: 1 },
                                    { label: '两节', value: 2 },
                                    { label: '三节', value: 3 },
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            name='startTime'
                            label={<span style={{ fontSize: '13px', fontWeight: '750', color: '#4E5969' }}>比赛时间</span>}
                            trigger='onConfirm'
                            onClick={() => datePickerRef.current?.open()}
                            rules={[{ required: true, message: '请选择开赛时间' }]}
                            arrow={false}
                        >
                            <DatePicker
                                ref={datePickerRef}
                                min={new Date()}
                                precision='minute'
                                title='选择开赛时间'
                            >
                                {(value) => (
                                    <div style={{ 
                                        padding: '14px', 
                                        background: '#F7F8FA', 
                                        borderRadius: '14px', 
                                        fontSize: '15px', 
                                        fontWeight: '700',
                                        color: value ? '#1D2129' : '#86909C',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        border: '1px solid #E5E6EB'
                                    }}>
                                        {value ? moment(value).format('YYYY-MM-DD HH:mm') : '📅 点击编排时间'}
                                    </div>
                                )}
                            </DatePicker>
                        </Form.Item>
                    </div>

                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <div style={{ display: 'inline-block', background: '#E8F3FF', color: '#165DFF', padding: '6px 20px', borderRadius: '25px', fontSize: '13px', fontWeight: '900', letterSpacing: '0.5px' }}>
                            选择对战双方
                        </div>
                    </div>

                    {/* Team A Card */}
                    <div style={getDynamicCardStyle(selectedColorA)}>
                        <Form.Item
                            name="teamA"
                            label={<span style={getDynamicLabelStyle(selectedColorA)}>A 队</span>}
                            rules={[{ required: true, message: '请选择A队' }]}
                        >
                            <Selector
                                columns={2}
                                className="premium-selector"
                                options={teamInfoList
                                    ?.filter(item => item.id !== selectedTeamB?.id) // Mutual Exclusivity
                                    ?.map(item => ({
                                        label: item.teamName,
                                        value: item
                                    }))}
                            />
                        </Form.Item>

                        <Form.Item
                            name="greenColor"
                            label={<span style={{ fontSize: '12px', color: '#86909C', fontWeight: '600' }}>A 队队服颜色（默认绿色）</span>}
                            rules={[{ required: true }]}
                        >
                            <Selector
                                columns={3}
                                className="premium-selector"
                                options={colorOptions
                                    ?.filter(opt => opt.value !== selectedColorB) // Mutual Exclusivity
                                    ?.map(opt => ({
                                        ...opt,
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '13px', fontWeight: '600' }}>
                                                <div style={{ width: '14px', height: '14px', borderRadius: '4px', background: opt.value, border: '1px solid rgba(0,0,0,0.05)' }}></div>
                                                {opt.label}
                                            </div>
                                        )
                                    }))}
                            />
                        </Form.Item>
                    </div>

                    {/* Team B Card */}
                    <div style={getDynamicCardStyle(selectedColorB)}>
                        <Form.Item
                            name="teamB"
                            label={<span style={getDynamicLabelStyle(selectedColorB)}>B 队</span>}
                            rules={[{ required: true, message: '请选择B队' }]}
                        >
                            <Selector
                                columns={2}
                                className="premium-selector"
                                options={teamInfoList
                                    ?.filter(item => item.id !== selectedTeamA?.id) // Mutual Exclusivity
                                    ?.map(item => ({
                                        label: item.teamName,
                                        value: item
                                    }))}
                            />
                        </Form.Item>

                        <Form.Item
                            name="redColor"
                            label={<span style={{ fontSize: '12px', color: '#86909C', fontWeight: '600' }}>B 队队服颜色（默认红色）</span>}
                            rules={[{ required: true }]}
                        >
                            <Selector
                                columns={3}
                                className="premium-selector"
                                options={colorOptions
                                    ?.filter(opt => opt.value !== selectedColorA) // Mutual Exclusivity
                                    ?.map(opt => ({
                                        ...opt,
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '13px', fontWeight: '600' }}>
                                                <div style={{ width: '14px', height: '14px', borderRadius: '4px', background: opt.value, border: '1px solid rgba(0,0,0,0.05)' }}></div>
                                                {opt.label}
                                            </div>
                                        )
                                    }))}
                            />
                        </Form.Item>
                        {selectedTeamA?.teamType === 1 || selectedTeamB?.teamType === 1 ?
                            <div className="year-create-external-hint">外战队伍无需排阵；创建后代表球员会自动作为门将并确认。</div> : null}
                    </div>
                </Form>
            </div>
        </div>
    )
}
